import { format } from 'date-fns'
import styled from 'styled-components'

import { ItemHeader } from '@/components/Style/Common'
import type { CompanyDetails } from '@/types/Activity'

import CorporateAddress from './CompanyAddress'
import CompanyVerification from './CompanyVerification'

interface Props {
  company: CompanyDetails
}

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
`

const VerifiedBy = styled.p`
  margin: 0;
`

const OrganisationalDetailsCard: React.FC<Props> = ({
  company: { name, companyNumber, address, incorporationDate, verification },
}) => {
  return (
    <>
      {verification?.verifiedBy && (
        <VerifiedBy>
          The organisation details has been verified by{' '}
          <strong>{verification.verifiedBy.name}</strong> ({verification.verifiedBy.email}
          )
        </VerifiedBy>
      )}
      <div>
        <h4>Declared by applicant</h4>
        <hr />
        <DetailRow>
          <div>
            <ItemHeader>Company Name</ItemHeader>
            <p>{name}</p>
          </div>
          <div>
            <ItemHeader>Company Number</ItemHeader>
            {companyNumber ? <p>{companyNumber}</p> : <p>Unknown</p>}
          </div>

          <div>
            <ItemHeader>Incorporation Date</ItemHeader>
            {incorporationDate ? (
              <p>{format(new Date(incorporationDate), 'dd/MM/yyyy')}</p>
            ) : (
              <p>Unknown</p>
            )}
          </div>
          <CorporateAddress address={address} />
        </DetailRow>
        {verification && <CompanyVerification verification={verification} />}
      </div>
    </>
  )
}

export default OrganisationalDetailsCard
